const loadGoogleMapsApi = require('load-google-maps-api');

class Map {
  
    static loadGoogleMapsApi() {
      return loadGoogleMapsApi({ key: "AIzaSyD5Zo4FCitnTgCGBvTBvzgj5lK87s07X1A" });
    }
    static createMap(googleMaps, mapElement) {
        var mapData    = { pos: { lat: 38.261268, lng: 140.319616 }, zoom: 16};
        //マーカー情報(情報ウインドウ含む)
        var markerData = [
            { pos: { lat: 38.261268, lng: 140.319616 }, title: "エイブルシステム", icon:{url: "https://www.ablesystem.co.jp/img/ico_map.png", scaledSize: new google.maps.Size(97, 104)}, infoWindowOpen: false},
        ];
        //地図の設定と作成
        var map = new google.maps.Map(document.getElementById('map'), {
            center: mapData.pos,
            zoom:   mapData.zoom,
            mapTypeControl: false,
            panControl: false,
            scaleControl: false,
            streetViewControl: false,
            styles: [
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#3cb37a"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#3cb37a"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "gamma": "1.37"
                        },
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "gamma": "2.78"
                        },
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#0075c2"
                        }
                    ]
                }
            ]
        });
        for( var i=0; i < markerData.length; i++ )
        {
            //即時関数
            (function(){
                //マーカーの設定と作成
                var marker = new google.maps.Marker({
                    position: markerData[i].pos,
                    title:    markerData[i].title,
                    icon:     markerData[i].icon,
                    map: map
                });
                /*if( markerData[i].infoWindowContent )
                {
                    //情報ウインドウの設定と作成
                    var infoWindow = new google.maps.InfoWindow({
                        content: markerData[i].infoWindowContent
                    });
                    //情報ウインドウのオープンをマーカーのクリックイベントに登録
                    marker.addListener('click', function(){
                        infoWindow.open(map, marker);
                    });
                    //情報ウインドウのオープン
                    if( markerData[i].infoWindowOpen )
                    {
                        infoWindow.open(map, marker);
                    }
                }*/
            }());
        }
    }
  }
export { Map };
